export enum ApplicationModules {
  AUDIT = 'auditoria',
  EXAMS = 'exames',
  FINANCIAL = 'financeiro',
  MANAGEMENT = 'gestao',
  ONLINE_CLASS = 'teleAula',
  PERSONAL_DATA = 'dadosPessoais',
  PRACTICAL_COURSE = 'cursoPratico',
  REGISTER = 'cadastro',
  THEORETICAL_COURSE = 'cursoTeorico',
  USER_SETTINGS = 'configuracoesDeUsuarios',
  LOG = 'log',
  REPORTS = 'relatorios',
}
